<div class="dropdown-menu shadow dropdown-menu-right animated--grow-in show">
  <div class="dropdown-divider"></div>
  <div class="dropdown-item" (click)="logout()">
    <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400">
    </i>Me déconnecter
  </div>
</div> 
